<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      @fileUploaded="initialise"
      :showBatchFilter="true"
      :programs="programs"
      @batchFilter="(v) => (yearFilter = v)"
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="filteredBatches"
            :single-expand="true"
            item-key="name"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.program_name`]="{ item }">
              <span
                @click="navigateToSchedules(item)"
                style="
                  cursor: pointer;
                  color: #4f4584;
                  text-decoration: underline;
                "
                >{{ item.program_name }}</span
              >
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon
                :disabled="!item.active"
                small
                class="mr-2"
                color="accent"
                @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template v-slot:[`item.set_term`]="{ item }">
              <v-icon
                class="mr-2"
                color="accent"
                @click="navigateToScheduleTerms(item)"
              >
                mdi-dots-horizontal
              </v-icon>
            </template>
            <template #[`item.active_status`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ item.active_status }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createBatch"
        @update="updateBatch"
        :batch="batch"
        :programs="programs"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="batch"
      :name="currentItem.year + '-' + currentItem.batch"
      :active="currentItem.active"
    />

    <v-dialog v-model="showDataDialog" max-width="600" persistent scrollable>
      <v-card class="secondary">
        <v-card-title class="primary white--text"
          >{{ selectedItem.name }} - {{ selectedItem.content_name }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="showDataDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="mt-3 reset-card-text">
          <div v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/batch/form.vue";
import searchBar from "@/components/searchBarFilter.vue";
import { batchHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      showDialog: false,
      currentItem: {},
      batches: [],
      programs: [],
      search: "",
      yearFilter: null,
      headers: batchHeaders,
      selectedItem: {},
      showDataDialog: false,
      batch: {},
    };
  },
  watch: {},
  computed: {
    filteredBatches() {
      if (!this.yearFilter) return this.batches;
      return this.batches.filter(
        (batch) => batch.year_batch === this.yearFilter,
      );
    },
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Batches" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getBatches();
      this.getPrograms();
    },
    async getBatches() {
      await this.$axios
        .get("program_batches")
        .then((res) => {
          this.batches = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrograms() {
      await this.$axios.get("programs").then((res) => {
        this.programs = res.data.data;
      });
    },
    async createBatch(data) {
      await this.$axios
        .post("program_batches", { program_batch: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateBatch(data) {
      await this.$axios
        .put("program_batches/" + data.id, { program_batch: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Batch updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateBatch({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    edit(item) {
      this.batch = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.batch = {};
    },
    navigateToSchedules(item) {
      this.$router.push({
        path: `/partner_schedule`,
        query: {
          batch_id: item.id,
        },
      });
    },
    navigateToScheduleTerms(item) {
      this.$router.push({
        path: "/program_batch_term_schedule",
        query: {
          batch_id: item.id,
        },
      });
    },
    showData(name, content, content_name) {
      this.showDataDialog = true;
      this.selectedItem.description = content;
      this.selectedItem.name = name;
      this.selectedItem.content_name = content_name;
    },
  },
};
</script>

<style>
.reset-card-text {
  font-size: medium !important;
  font-weight: normal !important;
  line-height: normal !important;
  letter-spacing: normal !important;
}
</style>
